
import React from 'react';
import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';

interface EditModePanelProps {
  onShowResetDialog: () => void;
  onExitEditMode: () => void;
  bottomNavigation?: boolean;
}

const EditModePanel: React.FC<EditModePanelProps> = ({
  onExitEditMode,
  bottomNavigation = false,
}) => {
  // Position the panel above bottom navigation when it's enabled
  // Use higher z-index to ensure it appears above other UI elements
  // When bottom navigation is enabled, use custom class that accounts for safe areas
  const positionClasses = bottomNavigation 
    ? "fixed left-0 right-0 z-[60] iphone-safe-edit-panel-above-nav" // Position above bottom navigation with safe area support
    : "fixed bottom-0 left-0 right-0 z-[60]"; // Default position at bottom

  return (
    <div className={`${positionClasses} p-4 bg-background/90 backdrop-blur-sm border-t`}>
      <div className="max-w-3xl mx-auto flex justify-center">
        <Button
          onClick={onExitEditMode}
          size="sm"
          className="flex items-center gap-2"
        >
          <LogOut className="h-4 w-4" />
          Exit Edit Mode
        </Button>
      </div>
    </div>
  );
};

export default EditModePanel;
